import styled, { css, gapSize, hoverFocus, rem, screenMobilePlusAndSmaller, tablet } from 'theme';
import borderRadius from 'theme/global/border-radius';
import boxShadow from 'theme/global/box-shadow';

interface WeroProps {
  $isWeroEnabled: boolean;
}

export const Card = styled('div')<WeroProps>`
  width: 100%;
  max-width: ${({ $isWeroEnabled }) => rem($isWeroEnabled ? 512 : 500)};
  border-radius: ${borderRadius.base};
  box-shadow: ${boxShadow.section};
  background-color: var(--ref-color-blackwhite-white);
  margin: 0 auto;
  transform: translateY(${() => gapSize(-4)});
`;

export const PaymentOption = styled('button')<WeroProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${({ $isWeroEnabled }) => ($isWeroEnabled ? gapSize(3) : `${gapSize(6)} 0 ${gapSize(3)}`)};

  background-color: var(--ref-color-blackwhite-white);
  width: 100%;
  height: ${({ $isWeroEnabled }) => rem($isWeroEnabled ? 160 : 150)};
  border: var(--sys-border-width-sm) solid var(--ref-color-blackwhite-white);
  transition: 300ms ease-in-out;

  &:first-of-type {
    border-top-left-radius: ${borderRadius.base};
    border-top-right-radius: ${borderRadius.base};
    border-bottom: ${rem(1)} solid var(--ref-color-gray-20);
  }

  &:last-of-type {
    border-bottom-left-radius: ${borderRadius.base};
    border-bottom-right-radius: ${borderRadius.base};
  }

  ${() =>
    hoverFocus(css`
      cursor: pointer;
      background-color: var(--ref-color-gray-10);
      border-color: var(--ref-color-silver-60);
    `)}

  ${({ $isWeroEnabled }) =>
    screenMobilePlusAndSmaller(css`
      padding: 0 ${gapSize(2)};
      ${$isWeroEnabled ? `height: ${rem(140)};` : ''}
    `)}
`;

export const PaymentOptionText = styled('div')<WeroProps>`
  width: 100%;
  text-align: ${({ $isWeroEnabled }) => ($isWeroEnabled ? 'center' : 'left')};
`;

export const IconWrapper = styled('div')<WeroProps>`
  min-width: ${({ $isWeroEnabled }) => rem($isWeroEnabled ? 80 : 160)};
  text-align: center;

  ${({ $isWeroEnabled }) =>
    !$isWeroEnabled &&
    screenMobilePlusAndSmaller(css`
      min-width: ${rem(120)};
    `)}
`;

const Iframe = styled('iframe')`
  border: none;
  height: 100%;
  width: 100%;
`;

export const IdealIframe = styled(Iframe)<WeroProps>`
  ${({ $isWeroEnabled }) =>
    $isWeroEnabled
      ? css`
          min-height: ${rem(350)};
        `
      : css`
          height: ${rem(122)};
          min-width: 265px;
          min-height: 117px;
          width: ${rem(320)};
          max-width: 100%;
          margin: 0 auto;

          ${tablet(css`
            margin: 0 0 0 auto;
            width: ${rem(262)};
          `)}
        `}
`;

export const CreditcardIframe = styled(Iframe)`
  height: ${rem(450)};
`;

export const IframeWrapper = styled('div')<WeroProps>`
  ${({ $isWeroEnabled }) =>
    $isWeroEnabled
      ? css`
          padding: ${gapSize(2)};
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: ${rem(16)};
          svg {
            height: ${rem(64)};
          }
        `
      : css`
          padding: ${gapSize(6)};
          display: flex;

          svg {
            width: ${rem(84)};
            height: ${rem(72)};
          }

          ${screenMobilePlusAndSmaller(css`
            padding: ${gapSize(1)};
            flex-direction: column;
            align-items: center;

            svg {
              margin: ${gapSize(2)} 0;
            }
          `)}
        `}
`;

export const ErrorContainer = styled('div')`
  padding: ${() => gapSize(2)};
`;
